import React from "react";

import "./Window.css";

export default class Window extends React.Component<Window.Props, Window.State>
{


    constructor(props: Window.Props)
    {
        super(props);
    }


    close()
    {
        if (this.props.close)
        {
            this.props.close();
        }
        else
        {
            app.closeLastWindow();
        }
    }


    renderHeader()
    {
        if (this.props.header)
        {
            return this.props.header;
        }

        return (
            <div className="label">
                {this.props.title}
            </div>
        );

    }


    render()
    {
        return (
            <div className="window">
                <div className="background"
                    onClick={this.close.bind(this)}
                ></div>
                <div
                    className="view"
                    id={this.props.id}
                >
                    <div className="header font_upper">
                        {this.renderHeader()}
                        <div className="button"
                            onClick={this.close.bind(this)}
                        >×</div>
                    </div>
                    <div
                        className="window_content"
                    >
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }


}

export namespace Window
{


    export interface Props
    {
        title: string;
        id: string;
        header?: JSX.Element;
        close?: () => void;
    }


    export interface State
    {

    }


}